import React, { useState, useEffect, useCallback } from 'react';
import { getAllSlot, updateClientTask } from '../Services/masterService';
// Mock data for slots - In a real app, this would come from an API or props


const UpdateTaskModal = ({ isOpen, onClose, taskData, onSubmit }) => {
    // Internal state to manage form fields
    const [slotList, setSlotList] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState({
        priority: '',
        slotId: '',
        description: '',
    });

    const fetchTasks = useCallback(async () => {
            // setIsLoading(true);
            // setApiMessage({ type: '', text: '' });
    
            try {
                const response = await getAllSlot();
                if (response.status === 1) {
                    setSlotList(response.data);
                } else {
                    setSlotList([]);
                }
            } catch (error) {
                alert({ type: 'error', text: 'Network error occurred while fetching data.' });
            } finally {
                // setIsLoading(false);
            }
            
        }, []);
    
        // Load initial data on mount
        useEffect(() => {
            fetchTasks();
        }, [fetchTasks]);

    // When the modal opens, pre-fill the form with the current task data
    useEffect(() => {
        if (taskData) {
            setFormData({
                priority: taskData.priority || 'NORMAL',
                slotId: taskData.slotId || '',
                description: taskData.description || '',
            });
        }

        console.log('UpdateTaskModal: ', taskData)
    }, [taskData]); // This effect runs whenever the taskData prop changes

    // Generic handler for form input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        // Construct the exact payload required by the API
        const payload = {
            taskId: taskData.id, // Use the original task ID
            slotId: parseInt(formData.slotId, 10),
            priority: formData.priority,
            description: formData.description,
        };

        // Call the submission function passed down from the parent
        try {
            // This 'onSubmit' is the async handleUpdateSubmit function from TaskList
            await onSubmit(payload); 
        } catch (error) {
            console.error("Submission failed", error);
        } finally {
            // This ensures the loading state is turned off even if there's an error
            setIsSubmitting(false); 
        }
    };

    if (!isOpen) {
        return null; // Don't render anything if the modal is not open
    }

    return (
        // Main modal overlay
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg transform transition-all">
                {/* Modal Header */}
                <div className="bg-gradient-to-r from-emerald-600 to-green-600 p-5 flex justify-between items-center rounded-t-xl">
                    <h2 className="text-xl font-bold text-white">Update Task Details</h2>
                    <button onClick={onClose} className="text-white hover:text-green-200 text-2xl">&times;</button>
                </div>

                {/* Modal Body with Form */}
                <form onSubmit={handleSubmit}>
                    <div className="p-6 space-y-6">
                        {/* Priority Selection */}
                        <div>
                            <label htmlFor="priority" className="block text-sm font-medium text-gray-700 mb-1">Priority</label>
                            <select
                                id="priority"
                                name="priority"
                                value={formData.priority}
                                onChange={handleChange}
                                className="w-full p-3 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-emerald-500 focus:outline-none"
                            >
                                <option value="NORMAL">Normal</option>
                                <option value="HIGH">High</option>
                            </select>
                        </div>

                        {/* Slot Selection */}
                        <div>
                            <label htmlFor="slotId" className="block text-sm font-medium text-gray-700 mb-1">Preferred Slot</label>
                            <select
                                id="slotId"
                                name="slotId"
                                value={formData.slotId}
                                onChange={handleChange}
                                className="w-full p-3 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-emerald-500 focus:outline-none"
                            >
                                <option value="">-- Select a Slot --</option>
                                {slotList.map(slot => (
                                    <option key={slot.id} value={slot.id}>{slot.startTime} - {slot.endTime}</option>
                                ))}
                            </select>
                        </div>

                        {/* Description Textarea */}
                        <div>
                            <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-1">Description</label>
                            <textarea
                                id="description"
                                name="description"
                                value={formData.description}
                                onChange={handleChange}
                                rows="4"
                                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:outline-none"
                                placeholder="Enter any additional details or instructions..."
                            />
                        </div>
                    </div>

                    {/* Modal Footer with Action Buttons */}
                    <div className="bg-gray-50 p-4 flex justify-end space-x-4 rounded-b-xl">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-6 py-2 bg-gray-200 text-gray-800 rounded-lg font-semibold hover:bg-gray-300 transition-colors"
                        >
                            Cancel
                        </button>
                        <button
                    type="submit"
                    disabled={isSubmitting} // Disable while submitting
                    className="px-6 py-2 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 disabled:bg-green-400"
                >
                    {isSubmitting ? 'Saving...' : 'Save Changes'}
                </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UpdateTaskModal;
